import { useTranslation } from "react-i18next";

import { register } from "@/lib/override";

const AuthHeroBase = () => {
  const { t } = useTranslation();

  return (
    <div className="login-hero order-last relative flex flex-auto flex-col justify-between p-6 md:order-first md:h-full md:w-[calc(50%+130px)] md:flex-none md:p-0 md:px-16 md:pr-[calc(4rem+130px)]">
      <div></div>
      <div className="mt-4 flex flex-col items-start rounded-lg py-4 md:mt-12">
        <div className="mb-6 hidden items-center md:flex">
          <img
            src="/images/avitra_logo_white.png"
            className="h-12"
            alt="Avitra"
          />
        </div>
        <div className="max-w-lg">
          <h1 className="text-4xl font-black leading-tight tracking-wider text-white lg:text-5xl">
            Avitra
          </h1>
          <div className="max-w-xl py-6 pl-1 text-base font-semibold text-secondary-400 md:text-lg lg:text-xl">
            {t("avitra_login_tagline")}
          </div>
        </div>
      </div>
      <div className="mb-6 flex items-center">
        <div className="max-w-lg text-xs text-secondary-500 md:text-sm">
          © {new Date().getFullYear()} Avitra
        </div>
      </div>
    </div>
  );
};

export const AuthHero = register("AuthHero", AuthHeroBase);
